// #region Imports
import { Navigate, useLocation } from "react-router-dom";
import LanguageContext from "../../libs/context/LanguageContext";
import { useClientAppSettings, useToken } from "../../libs/hooks";
// #endregion

// #region Component
/**
 * Catch-all for paths that look like a client app segment (see AppRoutes).
 * Reads `pathname` from `useLocation()`, syncs `AppName` in session when it changes, then uses `<Navigate replace />` to "/" (React Router v6; same replace semantics as v5 `<Redirect />`).
 * Other client-specific bootstrap can be added here (e.g. locale, API calls).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export default function InitialiseClient(): JSX.Element {
  const { setToken } = useToken();
  const { app, setClientApp } = useClientAppSettings();
  const { pathname } = useLocation();
  const appNameFromPath = pathname.replace("/", "");
  // update local storage only if the app name has changed
  if (appNameFromPath !== app.AppName) {
    setToken({ token: "" });
    setClientApp({
      AppName: appNameFromPath,
      ClientName: "",
      ClientFullName: "",
      ClientLogo: "",
      CopyrightYear: "",
      ForceReadOnly: false,
      DisableSelfRegistration: false,
      DatabaseLock: true,
      DatabaseLockText: "",
      siteLanguage: "",
      portalDefaultLanguage: "",
      ShowForgotPasswordLink: false,
      dateFormat: "",
    });
  }
  return (
    <LanguageContext.Consumer>
      {({ locale, updateLocale }) => {
        return <Navigate to="/" replace />;
      }}
    </LanguageContext.Consumer>
  );
}
// #endregion
